import { DisplaySize } from '../enum/EnumRepository';

export type DisplaySizeValueMap = Record<DisplaySize, number>;

export type DisplaySizeImageDimensions = {
  widthVw: DisplaySizeValueMap;
  heightVh: DisplaySizeValueMap;
};

export const PROJECT_IMAGE_SIZE: DisplaySizeImageDimensions = {
  widthVw: {
    [DisplaySize.SMALL]: 50,
    [DisplaySize.REGULAR]: 65,
    [DisplaySize.MEDIUM]: 75,
    [DisplaySize.BIG]: 85,
    [DisplaySize.WIDE]: 100,
  },
  heightVh: {
    [DisplaySize.SMALL]: 45,
    [DisplaySize.REGULAR]: 55,
    [DisplaySize.MEDIUM]: 65,
    [DisplaySize.BIG]: 80,
    [DisplaySize.WIDE]: 100,
  },
};

export const BILLBOARD_IMAGE_SIZE: DisplaySizeImageDimensions = {
  heightVh: {
    [DisplaySize.SMALL]: 50,
    [DisplaySize.REGULAR]: 60,
    [DisplaySize.MEDIUM]: 70,
    [DisplaySize.BIG]: 80,
    [DisplaySize.WIDE]: 90,
  },
  widthVw: {
    [DisplaySize.SMALL]: 60,
    [DisplaySize.REGULAR]: 70,
    [DisplaySize.MEDIUM]: 80,
    [DisplaySize.BIG]: 85,
    [DisplaySize.WIDE]: 90,
  },
};

export const getDisplaySizeValue = (
  displaySize: DisplaySize,
  valueMap: DisplaySizeValueMap
): number => valueMap[displaySize] ?? valueMap[DisplaySize.WIDE];

export const getSafeImageRatio = (imageRatio?: number): number | undefined => {
  return imageRatio && Number.isFinite(imageRatio) && imageRatio > 0 ? imageRatio : undefined;
};

export const getCompactPortraitHeight = (
  displaySize: DisplaySize,
  imageRatio: number | undefined,
  { heightVh, widthVw }: DisplaySizeImageDimensions,
): string => {
  const targetHeight = getDisplaySizeValue(displaySize, heightVh);
  const safeImageRatio = getSafeImageRatio(imageRatio);
  if (!safeImageRatio) {
    return `${targetHeight}vh`;
  }

  const maxWidth = getDisplaySizeValue(displaySize, widthVw);
  return `min(${targetHeight}vh, ${maxWidth / safeImageRatio}vw)`;
};

export const getCompactLandscapeWidth = (
  displaySize: DisplaySize,
  imageRatio: number | undefined,
  { heightVh, widthVw }: DisplaySizeImageDimensions,
): string => {
  const targetWidth = getDisplaySizeValue(displaySize, widthVw);
  const safeImageRatio = getSafeImageRatio(imageRatio);
  if (!safeImageRatio) {
    return `${targetWidth}vw`;
  }

  const maxHeight = getDisplaySizeValue(displaySize, heightVh);
  return `min(${targetWidth}vw, ${maxHeight * safeImageRatio}vh)`;
};
